import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/pro-light-svg-icons';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import styles from './index.module.scss';
import { useLoadMp } from 'src/models/matchingProfiles/hooks';
import { trackMPEditUpdateResults } from 'src/segment/events';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';

export const MpFooter: FC = () => {
  const { t } = useTranslation();
  const [{ vars: variables }] = useApiTenders();
  const sidebarState = useCurrentSidebar();
  const { data: mp, loading } = useLoadMp();
  const onUpdate = useCallback(() => {
    if (mp) {
      trackMPEditUpdateResults({ id: mp.id, name: mp.name });
    }

    sidebarState?.mp?.resetMPData(variables);
  }, [sidebarState, variables, mp]);

  return (
    <footer className={styles.footer}>
      <Button
        onClick={onUpdate}
        type={'primary'}
        disabled={!sidebarState?.mp?.isMPUpdated || loading}
        icon={<FontAwesomeIcon icon={faArrowsRotate} />}
      >
        {t('Tenders.updateResults')}
      </Button>
    </footer>
  );
};

export default MpFooter;
